<template>
  <el-dialog
    title="审批详情"
    :visible.sync="dialogVisible"
    width="60%"
    class="approvalDialog"
    @close="dialogCloseHandle"
  >
    <commonTable ref="approvalDetailsDialogTable" edit-trigger-mode="manual" @editClosed="editClosed" />
  </el-dialog>
</template>

<script>
import commonTable from '@/components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
import { approvalManagementApi, transferOrderApi } from '../../service';
export default {
  data () {
    return {
      dialogVisible: false,
      tableData: [],
      applyUserList: [],
      saleLoading: false,
      rowData: {}
    };
  },
  props: {
    approvalDialogVisible: {
      type: Boolean,
      default: false
    },
    expensesCode: {
      type: String,
      default: ''
    },
    ifReport: {
      type: String,
      default: ''
    }
  },
  components: {
    commonTable
  },
  watch: {
    approvalDialogVisible (val) {
      if (val) {
        this.getDetailsData();
      }
      this.dialogVisible = val;
    }
  },
  methods: {
    arrayQuery (val, list, findKey) {
      return list.find(item => {
        return item[findKey] === val;
      });
    },
    jumpHandle (row) {
      this.$store.commit('setSubPageLoading', true);
      transferOrderApi.jumpApprove(row.taskId).then(res => {
        this.$store.commit('setSubPageLoading', false);
        if (res.status === '200') {
          this.$message.success('操作成功');
          this.$emit('jumpHandle');
        }
      });
    },
    replace (row) {
      this.rowData = JSON.parse(JSON.stringify(row));
      this.$refs.approvalDetailsDialogTable.setActiveRow(row);
    },
    editClosed ({ row }) {
      let params = {
        id: row.id,
        assigneeId: row.assigneeId,
        assigneeName: row.assigneeName
      };
      if (this.rowData.assigneeId === params.assigneeId && this.rowData.assigneeName === params.assigneeName) {
        return;
      }
      this.$refs.approvalDetailsDialogTable.loading = true;
      transferOrderApi.updateAssignee(params).then(res => {
        if (res.status === '200') {
          this.$message.success('替换成功');
        } else {
          this.$refs.approvalDetailsDialogTable.reviseRow(this.rowData);
        }
        this.$refs.approvalDetailsDialogTable.loading = false;
      });
    },
    getDetailsData () {
      if (this.expensesCode) {
        transferOrderApi.approveDetails({ id: this.expensesCode, ifReport: this.ifReport }).then(res => {
          if (res.status === '200') {
            this.tableData = res.data.map(item => {
              return {
                ...item,
                approvalStateText: item.approvalStat === 1 ? '待审批' : '已审批'
              };
            });
            this.loadTable();
          }
        });
      }
    },
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    },
    loadTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title('序号')
          ._width('10%')
          ._others('seq')
      );
      tableRow.push(
        new TableColumns()
          ._title('角色')
          ._width('10%')
          ._data('node')
      );
      tableRow.push(
        new TableColumns()
          ._title('审批人')
          ._width('10%')
          ._data('assigneeName')
          ._editType('editSelect')
          ._editData({
            options: this.applyUserList,
            optionProps: {
              label: 'userName',
              value: 'userName',
              filterable: true,
              remote: true,
              reserveKeyword: true,
              loading: this.saleLoading,
              remoteMethod: (data) => {
                if (data !== '') {
                  this.saleLoading = true;
                  approvalManagementApi.getApprovedList(data).then(res => {
                    if (res.status === '200') {
                      this.applyUserList = res.data ? res.data : [];
                      this.saleLoading = false;
                      this.loadTable();
                    }
                  });
                } else {
                  this.applyUserList = [];
                  this.loadTable();
                }
              }
            },
            events: {
              change: ({ row }) => {
                let userData = this.arrayQuery(row.assigneeName, this.applyUserList, 'userName');
                row.assigneeId = userData.userId;
              }
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('操作人邮箱前缀')
          ._width('10%')
          ._data('assigneeId')
      );
      tableRow.push(
        new TableColumns()
          ._title('状态')
          ._width('10%')
          ._data('approvalStateText')
      );
      tableRow.push(
        new TableColumns()
          ._title('操作')
          ._width('15%')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="text" onClick={() => { this.replace(row); }}>
                    替换审批人
                  </el-button>
                  {
                    row.approvalStat === 1 ? (
                      <el-button type="text" onClick={() => { this.jumpHandle(row); }}>跳过</el-button>
                    ) : null
                  }
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.approvalDetailsDialogTable.setColumn(column, {
        page: false
      });
      this.$refs.approvalDetailsDialogTable.loadStaticTable(this.tableData);
    }
  }
};
</script>

<style scoped>

</style>
